import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../pages/Sidebar";
import { Outlet } from "react-router-dom";
import Header from "../component/Header/Header";
import "../App.css"
import Footer from "../component/Footer/Footer";

const PrivateLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const sidebarRef = useRef(null);
  const menuButtonRef = useRef(null); // This should be passed to Header

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Close sidebar on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <div className="private-layout">
      <Header toggleSidebar={toggleSidebar} menuButtonRef={menuButtonRef} />

      <div className="layout-container">
        <div
          className={`sidebar ${isSidebarOpen ? "open" : ""}`}
          ref={sidebarRef}>
          <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        </div>

        <div className="content">
          <Outlet />
        </div>
      </div>
      <div className="footer_div">
        <Footer />
      </div>
    </div>
  );
};

export default PrivateLayout;
